export const convertObjectToParams = (obj: any): string => {
  return (
    '/?' +
    Object.keys(obj)
      .map(function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]);
      })
      .join('&')
  );
};

// TODO: return Record<string, string> | undefined. Callers currently destructure without a guard and pass these
// string IDs where numbers are expected, so tightening the type surfaces errors across members and peer-profiles.
export const paramsToObjects = (): any => {
  const search = window.location.search.substring(1);
  return search.length > 0 ? Object.fromEntries(new URLSearchParams(search)) : undefined;
};
